/**
 * Close — personal-space offer path.
 */

'use client'

import React from 'react'
import Image from 'next/image'
import Link from 'next/link'

export const CTASection: React.FC = () => {
  return (
    <section className="lp-section lp-section-close" id="start" aria-labelledby="cta-title">
      <div className="lp-close">
        <div className="lp-close-glow" aria-hidden="true" />
        <div className="lp-close-inner">
          <div className="lp-close-agent lp-close-agent-window" aria-hidden="true">
            <Image
              src="/assets/brand/agent-cta.png"
              alt=""
              width={160}
              height={160}
              className="lp-close-agent-img"
              loading="lazy"
            />
          </div>
          <div className="lp-close-copy">
            <h2 id="cta-title" className="lp-close-title">
              Name the Agent. Open the Paper Desk.
            </h2>
            <p className="lp-close-lede">
              Free Desk includes one named PAPER agent, market and portfolio views, research chat,
              and 200 paper-only Desk Credits. No card and no live execution.
            </p>
            <div className="lp-actions">
              <Link
                href="/auth/client-register"
                className="landing-btn landing-btn-primary landing-btn-lg"
              >
                Open Free Desk
                <span className="landing-btn-arrow" aria-hidden="true">
                  →
                </span>
              </Link>
              <Link href="/auth/login" className="landing-btn landing-btn-quiet landing-btn-lg">
                Sign In
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
